/**
 * IOT-PREDICTIVE-RISK-1 — per-shipment AI-derived risk score types.
 * Trust R7 bands: low <40 / medium 40-70 / high >70
 * Confidence <0.6 → score=null + insufficient-data narrative (KAUDIT-8)
 */
import { z } from 'zod';

export const RiskBandValues = /** @type {const} */ (['low', 'medium', 'high']);
export const RiskBand = z.enum(RiskBandValues);

export const RiskFactor = z.object({
  factorKey:  z.string(),
  weight:     z.number().min(0).max(1),
  cited:      z.string(),
});

export const ShipmentRiskAssessment = z.object({
  id:                  z.string(),
  tenantId:            z.string(),
  shipmentId:          z.string(),
  score:               z.number().min(0).max(100).nullable(),
  band:                RiskBand.nullable(),
  factorCitations:     z.array(RiskFactor),
  narrativeBody:       z.string(),
  recommendedActions:  z.array(z.string()),
  confidence:          z.number().min(0).max(1),
  computedAt:          z.string(),
  ttlExpiresAt:        z.string(),
  correlationId:       z.string(),
  softDeleted:         z.boolean().optional().default(false),
});

/** @typedef {z.infer<typeof ShipmentRiskAssessment>} ShipmentRiskAssessmentType */
/** @typedef {z.infer<typeof RiskFactor>} RiskFactorType */
